import { Props as FormattedMessageProps } from 'react-intl/src/components/message';

import { ROIMetricDisplayType } from '@arrived/common';

import { ThemeFunction } from '../../utils';

export const ROIMetricDisplayText: Record<
  ROIMetricDisplayType,
  { formattedMessageProps: FormattedMessageProps; color: ThemeFunction<string> }
> = {
  [ROIMetricDisplayType.EQUITY]: {
    color: ({ palette }) => palette.tertiary[500],
    formattedMessageProps: {
      id: 'equity',
      defaultMessage: 'Your Equity',
    },
  },
  [ROIMetricDisplayType.RENTAL_INCOME]: {
    color: ({ palette }) => palette.primary.main,
    formattedMessageProps: {
      id: 'rental-income-returns',
      defaultMessage: 'Rental Income Returns',
    },
  },
};
